// extracted by mini-css-extract-plugin
export var createdDate = "_k6-1";
export var divider = "_k6-2";
export var headerDivider = "_k6-3";
export var messagesCard = "_k6-0";
export var messagesContainer = "_k6-6";
export var messagesContainerWrapper = "_k6-4";
export var showLeftPanelButton = "_k6-8";
export var topButtons = "_k6-7";
export var withPadding = "_k6-5";